/** Canonical public site URL (no trailing slash). Must match production and sitemap. */
export const canonicalBaseUrl = 'https://www.dieselcity.co.za';

export const siteName = 'Diesel City';

export const defaultOgImagePath = '/assets/frontReplace.jpeg';

export function pageCanonicalUrl(pathname) {
  const path = pathname === '/' ? '' : pathname;
  return `${canonicalBaseUrl}${path}`;
}
